import { DistinctValuesRequest } from "../../../services/cleaning-data-service";
import { ClientInformation } from "../../../../client-config/data/types";

/**
 * Builds the request body for the distinct values API.
 * Returns null if required parameters are missing.
 */
const buildDistinctValuesRequest = (
  selectedTile: number | null,
  clientsData: ClientInformation[] | undefined,
  selectedClientIds: number[],
  isLoadingClients: boolean,
): DistinctValuesRequest | null => {
  if (
    selectedTile === null ||
    !clientsData ||
    clientsData.length === 0 ||
    selectedClientIds.length === 0 ||
    isLoadingClients
  ) {
    return null;
  }

  const selectedClients = clientsData.filter((client) =>
    selectedClientIds.includes(client.id),
  );

  return {
    clients: selectedClients.map((client) => ({
      clientInformation: client,
    })),
    filter: selectedTile,
  };
};

export default buildDistinctValuesRequest;
